document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-sidebar-menu');
  const iconHamburger = menuToggle.querySelector('.icon-hamburger');
  const iconClose = menuToggle.querySelector('.icon-close');
  
  if (!menuToggle || !mobileMenu) return;

  menuToggle.addEventListener('click', function() {
    const isOpen = mobileMenu.classList.contains('active');
    
    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  function openMenu() {
    mobileMenu.classList.add('active');
    iconHamburger.classList.add('hidden');
    iconClose.classList.remove('hidden');
    menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu.classList.remove('active');
    iconHamburger.classList.remove('hidden');
    iconClose.classList.add('hidden');
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  mobileMenu.addEventListener('click', function(e) {
    if (e.target.tagName === 'A' && !e.target.closest('.disclosure__list-wrapper')) {
      closeMenu();
    }
  });

  // Account dropdown toggle
  const accountToggle = document.getElementById('account-dropdown-toggle');
  const accountDropdown = document.getElementById('account-dropdown');

  if (accountToggle && accountDropdown) {
    accountToggle.addEventListener('click', function(e) {
      e.preventDefault();
      const isOpen = !accountDropdown.hasAttribute('hidden');
      if (isOpen) {
        accountDropdown.setAttribute('hidden', '');
        accountToggle.setAttribute('aria-expanded', 'false');
      } else {
        accountDropdown.removeAttribute('hidden');
        accountToggle.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('click', function(e) {
      if (!accountToggle.contains(e.target) && !accountDropdown.contains(e.target)) {
        accountDropdown.setAttribute('hidden', '');
        accountToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Language globe toggle — listen on wrapper since tap lands on wrapper background
  document.querySelectorAll('[data-language-trigger]').forEach(function(wrapper) {
    const globeBtn = wrapper.querySelector('[data-globe-button]');
    const panel = wrapper.querySelector('.disclosure__list-wrapper');
    if (!globeBtn || !panel) return;

    let shouldOpen = null;

    wrapper.addEventListener('pointerdown', function() {
      shouldOpen = panel.hasAttribute('hidden');
    });

    wrapper.addEventListener('click', function() {
      if (shouldOpen === null) return;
      const open = shouldOpen;
      shouldOpen = null;
      setTimeout(function() {
        if (open) {
          panel.removeAttribute('hidden');
          globeBtn.setAttribute('aria-expanded', 'true');
        } else {
          panel.setAttribute('hidden', '');
          globeBtn.setAttribute('aria-expanded', 'false');
        }
      }, 0);
    });

    // Mobile: submit language form on touchend before any focusout can hide the panel
    panel.querySelectorAll('a[data-value]').forEach(function(link) {
      link.addEventListener('touchend', function(e) {
        e.preventDefault();
        var locForm = link.closest('localization-form');
        if (!locForm) return;
        var form = locForm.querySelector('form');
        var input = locForm.querySelector('input[name="locale_code"]');
        if (input && form) {
          input.value = link.dataset.value;
          form.submit();
        }
      });
    });
  });

  // Close language globe panels when tapping outside
  document.addEventListener('click', function(e) {
    document.querySelectorAll('[data-language-trigger]').forEach(function(wrapper) {
      const panel = wrapper.querySelector('.disclosure__list-wrapper');
      const btn = wrapper.querySelector('[data-globe-button]');
      if (!panel || panel.hasAttribute('hidden')) return;
      if (!wrapper.contains(e.target)) {
        panel.setAttribute('hidden', '');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });
  });

  // Country selector triggers
  const countryLabel = document.querySelector('[data-country-trigger]');
  const countryIconBtn = document.querySelector('[data-country-icon-trigger]');
  const countryDropdown = document.querySelector('[data-country-dropdown]');

  function toggleCountryDropdown(e) {
    if (e) e.preventDefault();
    const isOpen = !countryDropdown.hasAttribute('hidden');
    
    if (isOpen) {
      countryDropdown.setAttribute('hidden', '');
    } else {
      countryDropdown.removeAttribute('hidden');
    }
  }

  if (countryLabel && countryIconBtn && countryDropdown) {
    // Both label and icon button can toggle the dropdown
    countryLabel.addEventListener('click', toggleCountryDropdown);
    countryIconBtn.addEventListener('click', toggleCountryDropdown);

    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!countryLabel.contains(e.target) && 
          !countryIconBtn.contains(e.target) && 
          !countryDropdown.contains(e.target)) {
        countryDropdown.setAttribute('hidden', '');
      }
    });

    // Close dropdown when country is selected
    countryDropdown.addEventListener('click', function(e) {
      if (e.target.closest('a[data-value]')) {
        setTimeout(() => {
          countryDropdown.setAttribute('hidden', '');
        }, 100);
      }
    });
  }

  // Banner countdown timers
  document.querySelectorAll('.banner-countdown[data-countdown-end]').forEach(function(el) {
    const endTime = new Date(el.dataset.countdownEnd).getTime();
    if (isNaN(endTime)) return;

    const hours = el.querySelector('[data-unit="hours"]');
    const minutes = el.querySelector('[data-unit="minutes"]');
    const seconds = el.querySelector('[data-unit="seconds"]');

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      const diff = endTime - Date.now();
      if (diff <= 0) {
        hours.textContent = '00';
        minutes.textContent = '00';
        seconds.textContent = '00';
        return;
      }
      const totalSeconds = Math.floor(diff / 1000);
      hours.textContent = pad(Math.floor(totalSeconds / 3600));
      minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      seconds.textContent = pad(totalSeconds % 60);
    }

    tick();
    setInterval(tick, 1000);
  });

});
